import NewsPage from '@/pages/marketing/news-page';
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_protected/news/$id')({
  component: NewsPage,
});